<div class="dialog">
  <div class="header">
    <div class="title">Set filters</div>
    <button
      matDialogClose
      blazeIconButton
      class="close"
      (click)="closeDialog()"
      data-cy="Dialog:close"
    >
      <mat-icon svgIcon="close" />
    </button>
  </div>

  <div class="content">
    <blaze-complex-filter
      class="flex-col pl-8"
      [query]="dialogData.initialFilter"
      (queryChange)="queryChange($event)"
    />
  </div>

  <div class="action">
    <button blazeButton="primary" (click)="saveFilter()">Done</button>
  </div>
</div>
